/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { Col, Row, Card, Button, Image, Alert } from 'react-bootstrap';

import { HeroSection, EditProfileModal, Header } from '../components';
import {
  useSMupdateProfile,
  useSMmyProfilePage,
  useSMSetActiveUser,
  useSMSetInActiveUser,
  useSMchangePassword,
} from '../machines';
import { vappContainer, VApplication } from '../../../application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { ProfilePageService } from '../services';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { FileComp } from '../components/FileComp';
import { Loader } from '@/components';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/outline';
import { FormComp } from '../components/FormComponent';
import { setPassword } from '@/pages/SignIn/machines/signInUser/states';

const getSrv = () => {
  return vappContainer.get<ProfilePageService>(ProfilePageService.displayName);
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [isProfileExist, setIsProfileExist] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [passwordModal, setpasswordModal] = useState(false);
  const staticPageContentConfig = getSrv()?.agent.getStaticPageContentSync();
  const [data, setData] = useState({ ...staticPageContentConfig?.sampleData });
  const srv = getSrv();
  const { changePasswordMachine, changePasswordSend, changePasswordState } =
    useSMchangePassword({});
  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const theme = useTheme();

  const { setActiveUserSend, setActiveUserState } = useSMSetActiveUser({});
  const { setInActiveUserSend, setInActiveUserState } = useSMSetInActiveUser(
    {}
  );
  const [fontScale, setFontScale] = useState(0);

  const { myProfilePageMachine, myProfilePageSend, myProfilePageState } =
    useSMmyProfilePage({});

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    } else if (key === 'active') {
      setActiveUserSend('START', {});
    } else if (key === 'inactive') {
      setInActiveUserSend('START', {});
    } else if (key === 'password') {
      setpasswordModal(true);
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };
  const onEditProfile = (
    name: string,
    description: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ) => {
    const payload: any = {};
    if (name) {
      payload.name = name;
    }
    if (description) {
      payload.description = description;
    }
    if (phoneNumber) {
      payload.telephone = phoneNumber;
    }
    if (address) {
      payload.address = {
        addressLine1: address,
      };
    }
    if (website) {
      payload.website = website;
    }
    if (profileImg) {
      payload.logo = profileImg;
    }
    updateProfileSend('START', {
      payload: payload,
    });
  };
  const onRefresh = () => {
    myProfilePageSend('TRIGGER_REFRESH', {});
  };
  const onUpdateProfile = (data: any) => {
    console.log(`profile data`, data);
    setData(getSrv()?.agent.getStaticPageContentSync(data)?.sampleData);
    setShowNotificationModal(true);

    if (showModal) {
      setShowModal(false);
    }
    // updateProfileSend('START', {
    //   payload: {
    //     ...data,
    //   },
    // });
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        // <TweetyModal

        //   show={true}
        //   size={'lg'}
        //   scrollable={false}
        //   backdrop={'static'}
        //   submitButtonTitle={'Update'}
        //   onSubmit={onUpdateProfile}
        //   onHide={() => setShowModal(false)}
        //   title={'Update Profile'}
        //   tweetyWidgetProps={{
        //     fields: staticPageContentConfig?.formData?.fields,
        //     layout: staticPageContentConfig?.formData?.layout,

        //     initialData: myProfilePageState?.event?.data?.value?.initialData,
        //   }}
        // />
        <EditProfileModal
          showModal={true}
          initialData={data}
          fields={staticPageContentConfig?.formData?.fields}
          // key={new Date().toString()}
          layout={staticPageContentConfig?.formData?.layout}
          fileFields={staticPageContentConfig?.formData?.fileFields}
          validatorConfig={staticPageContentConfig?.formData?.validatorConfig}
          onAcknowledgement={onUpdateProfile}
          onDeny={() => setShowModal(false)}
        />
      );
    }
  };

  const _renderLoading = () => {
    if (setActiveUserState?.matches('SET_ACTIVE')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.updateActive || {})}
        />
      );
    }
    if (changePasswordState?.matches('CHANGE_PASSWORD')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.changePassword || {})}
        />
      );
    }
    if (setInActiveUserState?.matches('SET_INACTIVE')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.updateActive || {})}
        />
      );
    }
  };

  const _renderPage = () => {
    if (showForm) {
      return (
        <>
          <TweetyWidget
            labelColor={'#000000'}
            fields={staticPageContentConfig?.formData?.fields}
            // key={new Date().toString()}
            layout={staticPageContentConfig?.formData?.layout}
            validatorConfig={staticPageContentConfig?.formData?.validatorConfig}
            onFormSubmit={(payload: any) => {
              console.log('find->', payload);
              setData(
                getSrv()?.agent.getStaticPageContentSync(payload)?.sampleData
              );
              setShowNotificationModal(true);
            }}
            renderSubmitButton={() => (
              <Button
                type="submit"
                style={{ position: 'relative', top: '520px' }}
                onClick={() => setShowNotificationModal(true)}
              >
                Next
              </Button>
            )}
            initialData={{}}
            submitButtonLabel={'Next'}
          />
          <FileComp
            formFields={staticPageContentConfig?.formData?.fileFields}
          />
        </>
      );
    }
    if (!isProfileExist) {
      return (
        <>
          <Loader {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
        </>
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.updateProfile || {})} />
      );
    }
    if (myProfilePageState?.matches('RENDER_PAGE')) {
      console.log('find->', myProfilePageState?.event?.data?.value);
      return (
        <>
          <HeroSection
            {...data}
            {...(myProfilePageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
        </>
      );
    }
    if (myProfilePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingProfile || {})} />
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (myProfilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          description={[
            updateProfileState?.event?.data?.value,
            staticPageContentConfig?.error?.updateProfile?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (changePasswordState?.matches('CHANGE_PASSWORD_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.changePassword || {})}
          description={[changePasswordState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderNotification = () => {
    if (showNotificationModal) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.createProfileSuccess ||
            {})}
          onAcknowledgement={() => {
            setIsProfileExist(true);
            setShowForm(false);
            window.scrollTo(0, 0);
          }}
          onDeny={onRefresh}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderSetActive = () => {
    if (setActiveUserState?.matches('SET_ACTIVE_SUCCESS'))
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateActiveSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    if (changePasswordState?.matches('CHANGE_PASSWORD_SUCCESS'))
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.changePassword || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
  };
  const changePasswordForm = (formData: any) => {
    setpasswordModal(false);
    changePasswordSend('START', {
      payload: {
        ...formData,
      },
    });
  };
  const _renderPasswordModal = () => {
    if (passwordModal)
      return (
        <FormComp
          showModal={passwordModal}
          submitButtonLabel={'Update'}
          handleClose={() => {
            setpasswordModal(false);
          }}
          onFormSubmit={changePasswordForm}
        />
      );
  };
  const _renderSetInActive = () => {
    if (setInActiveUserState?.matches('SET_INACTIVE_SUCCESS'))
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateActiveSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
  };

  const onCreateProfile = () => {
    setShowForm(true);
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <div style={{ position: 'relative' }}>
          <Header
            backButton={showForm}
            onBackClick={() => setShowForm(false)}
            {...(staticPageContentConfig?.header || {})}
            headerAction1={
              isProfileExist
                ? null
                : staticPageContentConfig?.header?.headerAction1
            }
            onHeaderAction1Click={onCreateProfile}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderPasswordModal()}
      {_renderErrorModals()}
      {_renderNotification()}
      {_renderSetActive()}
      {_renderSetInActive()}
      {_renderLoading()}
    </>
  );
};
